import { useEffect } from 'react';

import { trackEvent } from '~/features/analytics/track-event';

/**
 * Note: Segment track event used primarily for Blueshift. See: https://udacity.atlassian.net/browse/CONENG-890
 */
export function usePLPViewedEvent({ nodeKey, isFree }: { nodeKey?: string; isFree?: boolean }) {
  useEffect(() => {
    if (typeof nodeKey === 'string' && typeof isFree === 'boolean') {
      trackEvent({
        type: 'view',
        name: 'Viewed Product Landing Page',
        label: 'viewed_product_landing_page',
        additionalAttributes: {
          product_ids: [nodeKey],
          paid_content: !isFree,
        },
      });
    }
  }, [nodeKey, isFree]);
}
